export default __webpack_public_path__ + "static/media/how-it-works-2-mob.83dba8cb.png";